import { css } from '@emotion/react';

export const mfaDialog = css`
  & .MuiDialogContent-root {
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
  }
`;

export const mfaDialogContent = css`
  display: flex;
  flex-direction: column;
`;

export const mfaDialogContentWithPadding = css`
  padding-top: 32px;
  padding-left: 32px;
  padding-right: 32px;
`;

export const logoWrapper = (color) => css`
  display: flex;
  height: 272px;
  align-items: center;
  justify-content: center;
  background-color: ${color};
`;

export const title = css`
  font-size: 26px;
  font-weight: 500;
  line-height: 34px;
  margin: 0;
`;

export const subtitle = css`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.4px;
  margin-bottom: 30px;
`;

export const hint = css`
  font-size: 11px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.4px;
  text-align: center;
`;

export const primaryButton = css`
  padding: 14px 24px 15px 24px;
`;

export const textButton = css`
  width: 100%;
  padding-top: 11px;
  text-decoration: underline;
  margin-bottom: 28px;
`;
